import { motion } from 'framer-motion';
import styles from './MoneyFlow.module.css';
import { Paper, Box, MenuItem, TextField, Button, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect } from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
    listClientApi,
    ListSdEmployeeApi,
    listServiceProviderApi,
    listVendorApi,
    moneyFlowLegderApi
} from 'utils/API/Superdistributor APIs/SuperdistributorApiCalls';
import { useLocation } from 'react-router';

const MoneyFlow = () => {
    const location = useLocation();
    const navigationType = location?.state?.type || 'employee'; // Default to 'employee' if not provided
    const [tableCounts, setTableCounts] = useState({
        totalRows: 0,
        page: 0,
        pageSize: 25,
        moneyflowData: [],
        entity: navigationType,
        entityId: null
    });

    const [loading, setLoading] = useState({
        fetchMoneyFlow: false,
        fetchEntities: false
    });
    const [dateRange, setDateRange] = useState({ from: null, to: null });
    const [entitiesId, setEntitiesId] = useState([]);
    const entityOptions = [
        { label: 'Client', value: 'client' },
        { label: 'Vendor', value: 'vendor' },
        { label: 'Employee', value: 'employee' },
        { label: 'Provider', value: 'provider' },
        { label: 'My Self', value: 'admin' }
    ];
    //table columns>>>
    const moneyFlowColumns = [
        {
            field: 'formatted_date',
            headerName: 'Transaction Date',
            minWidth: 160,
            flex: 1,
            valueGetter: (params) => params.row.formatted_date || '-'
        },
        {
            field: 'entity_name',
            headerName: 'Parties',
            flex: 1,
            minWidth: 160,
            valueGetter: (params) => (params.row.entity_name != null ? params.row.entity_name : '-')
        },
        {
            field: 'payment_mode',
            headerName: 'DR/CR',
            flex: 1,
            minWidth: 160,
            renderCell: (params) => {
                const mode = params.row?.payment_mode;
                const label = mode === 'debit' ? 'DR' : mode === 'credit' ? 'CR' : '-';
                const color = mode === 'debit' ? 'red' : mode === 'credit' ? 'green' : 'inherit';

                return <Typography style={{ color, fontWeight: 'bold' }}>{label}</Typography>;
            }
        },

        {
            field: 'opening_balance',
            headerName: 'Opening Balance',
            flex: 1,
            minWidth: 160,
            valueGetter: (params) => (params.row.opening_balance != null ? params.row.opening_balance : '-')
        },
        {
            field: 'amount',
            headerName: 'Amount',
            flex: 1,
            minWidth: 160,
            renderCell: (params) => {
                const amount = params.row.amount;
                const isPremium = params.row.txn_type === 'EMPLOYEE_PREMIUM_CHARGE';

                return (
                    <Typography>
                        {amount || '-'} {isPremium && <span style={{ color: 'blue', fontStyle: 'italic' }}>(Premium Charge)</span>}
                    </Typography>
                );
            }
        },
        {
            field: 'closing_balance',
            headerName: 'Closing Balance',
            flex: 1,
            minWidth: 160,
            valueGetter: (params) => (params.row.closing_balance != null ? params.row.closing_balance : '-')
        }

        // {
        //     field: 'txn_type',
        //     headerName: 'Transaction Type',
        //     flex: 1,
        //     minWidth: 160,
        //     valueGetter: (params) => (params.row.txn_type != null ? params.row.txn_type : '-')
        // }
    ];
    //handlers>>>
    const handlePageChange = (params) => {
        setTableCounts((prev) => ({ ...prev, page: params.page, pageSize: params?.pageSize }));
    };
    const handleClearClick = () => {
        setDateRange({ from: null, to: null });
        setTableCounts((prev) => ({
            ...prev,
            page: 0,
            pageSize: 25,
            entity: 'employee',
            entityId: null
        }));
    };
    const formatDateFunction = (inputData) => {
        const formattedData = inputData.map((item) => {
            const formattedDate = new Date(item.date_of_txn).toLocaleString('en-IN', {
                timeZone: 'Asia/Kolkata',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                // hour: '2-digit',
                // minute: '2-digit',
                hour12: true
            });
            return { ...item, formatted_date: formattedDate };
        });
        return formattedData;
    };

    const formattedMoneyFlowList = formatDateFunction(tableCounts.moneyflowData);

    //api calls>>>
    const handleListEntitiesApi = async (value) => {
        let response;
        setLoading((prev) => ({ ...prev, fetchEntities: true }));
        if (value === 'vendor') {
            const payload = { status: 'true' };
            response = await listVendorApi(payload);
        } else if (value === 'client') {
            const payload = { status: 'true', entity: value };
            response = await listClientApi(payload);
        } else if (value === 'provider') {
            const payload = { status: 'true' };
            response = await listServiceProviderApi(payload);
        } else if (value === 'employee') {
            response = await ListSdEmployeeApi();
        }

        if (response.status === 200) {
            let list;
            if (value === 'employee') {
                list = response?.data?.details?.success || [];
            } else {
                list = response?.data?.data || [];
            }
            return list;
        }
        setLoading((prev) => ({ ...prev, fetchEntities: false }));
    };
    const fetchMoneyFlowLedger = async () => {
        setLoading((prev) => ({ ...prev, fetchMoneyFlow: true }));
        const payload = {
            pageNumber: tableCounts.page + 1,
            pageSize: tableCounts.pageSize,
            // entity: 'employee',
            entity_id: tableCounts.entityId,
            fromDate: dateRange.from ? new Date(dateRange.from).toISOString() : undefined,
            toDate: dateRange.to ? new Date(dateRange.to).toISOString() : undefined,
            entity: tableCounts.entity
        };
        const response = await moneyFlowLegderApi(payload);
        if (response.status === 200) {
            const list = response?.data?.data;
            const rowCount = response?.data?.count;
            setTableCounts((prev) => ({ ...prev, totalRows: rowCount, moneyflowData: list }));
        }
        setLoading((prev) => ({ ...prev, fetchMoneyFlow: false }));
    };

    useEffect(() => {
        if (dateRange.from && dateRange.to) {
            fetchMoneyFlowLedger();
        }
        // eslint-disable-next-line
    }, [dateRange]);
    useEffect(() => {
        fetchMoneyFlowLedger();
        // eslint-disable-next-line
    }, [tableCounts.pageSize, tableCounts.page, tableCounts.entity, tableCounts.entityId]);
    useEffect(() => {
        if (tableCounts.entity !== 'admin') {
            handleListEntitiesApi(tableCounts.entity).then((list) => {
                const formattedList = list.map((item) => ({
                    label: item.name || item.company_name || item.username,
                    value: item._id || item.id,
                    entity: tableCounts.entity
                }));
                setEntitiesId(formattedList);
                setTableCounts((prev) => ({ ...prev, entityId: null }));
            });
        } else {
            setEntitiesId([]);
        }
    }, [tableCounts.entity]);
    return (
        <>
            <motion.div
                className={styles.container}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <h2 className={styles.sectionHeading}>Money Flow</h2>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Box display="flex" gap={2} mb={2}>
                        <DatePicker
                            label="From Date"
                            format="dd/MM/yyyy"
                            value={dateRange.from}
                            onChange={(newValue) => setDateRange((prev) => ({ ...prev, from: newValue }))}
                        />
                        <DatePicker
                            label="To Date"
                            format="dd/MM/yyyy"
                            value={dateRange.to}
                            onChange={(newValue) => setDateRange((prev) => ({ ...prev, to: newValue }))}
                        />
                        <TextField
                            select
                            label="Type"
                            value={tableCounts.entity || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setTableCounts((prev) => ({ ...prev, entity: value, page: 0 })); // Reset page on change
                            }}
                            className={styles.entitySelect}
                        >
                            {entityOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            select
                            label="Entity"
                            value={tableCounts.entityId || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setTableCounts((prev) => ({ ...prev, entityId: value, page: 0 })); // Reset page on change
                            }}
                            className={styles.entitySelect}
                        >
                            {entitiesId.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Button
                            variant="contained"
                            onClick={() => handleClearClick()}
                            disabled={loading.fetchMoneyFlow}
                            className={`${styles.addClientButton} ${styles.clearButton}`}
                        >
                            Clear
                        </Button>
                    </Box>
                </LocalizationProvider>
                <motion.div className={styles.tableWrapper} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
                    <Paper className={styles.tableContainer}>
                        <div className={styles.dataGridScrollWrapper}>
                            <DataGrid
                                rows={formattedMoneyFlowList}
                                columns={moneyFlowColumns}
                                paginationMode="server"
                                pagination
                                loading={loading.fetchMoneyFlow}
                                rowCount={tableCounts.totalRows}
                                rowsPerPageOptions={[100, 50, 25]}
                                page={0}
                                onPaginationModelChange={(params) => handlePageChange(params)}
                                getRowId={(row) => row.eid}
                                disableRowSelectionOnClick
                                sx={{
                                    border: 'none',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#f5f5f5',
                                        fontWeight: 'bold'
                                    },
                                    '& .MuiDataGrid-row:hover': {
                                        backgroundColor: '#f9f9f9'
                                    }
                                }}
                            />
                        </div>
                    </Paper>
                </motion.div>
            </motion.div>
        </>
    );
};
export default MoneyFlow;
